import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { mergeOverrides } from '@lyearn/ui';
import { Sort } from '@/components/FilterManager';

import EntityDefaultChildren from '../EntityFilter/components/EntityDefaultChildren';
import { SORT_MENU_OVERRIDES } from '../SortAndFilter/components/SortContainer/style';
import { SingleSelectFilterProps } from './types';

function SingleSelectFilter(props: SingleSelectFilterProps) {
  const { isMobile } = useScreen();
  const {
    items,
    clearable,
    defaultSortBy,
    defaultPlaceholder,
    onChange,
    selectedItems = [],
    selectedValues = [],
    children,
    disabled,
    overrides,
    filterId,
    selectedOperator,
    appearance,
  } = props;

  const mergedOverrides = mergeOverrides(SORT_MENU_OVERRIDES, overrides);

  return (
    <Sort
      actions={items}
      clearable={clearable}
      defaultSortBy={selectedValues?.[0] || selectedItems?.[0] || defaultSortBy}
      disabled={disabled}
      label={isMobile ? defaultPlaceholder : ''}
      overrides={mergedOverrides}
      showBottomSheet={isMobile}
      onSort={onChange}>
      {children ? (
        (children as any)
      ) : (
        <EntityDefaultChildren
          appearance={appearance}
          defaultPlaceholder={defaultPlaceholder ?? ''}
          id={`filter-${filterId}`}
          selectedOperator={selectedOperator}
          selectedValues={selectedItems}
        />
      )}
    </Sort>
  );
}

export default SingleSelectFilter;
